<template>
    <div class="container">
        <div class="site-form" @click="siteListPopup = true">
            <div class="site-form-left">
                <van-icon name="location-o" style="vertical-align: middle;" size="20" />
                {{ currentSiteInfo && currentSiteInfo.name || '请选择油站' }}
            </div>
            <div class="site-form-right">
                <template v-if="currentSiteInfo">
                    切换油站
                    <van-icon name="arrow" style="vertical-align: middle;" />
                </template>
            </div>
        </div>
        <div class="site-main-form">
            <div class="site-oil-gun-form" @click="oilGunListPopup = true">
                <div class="site-oil-gun-form-title">油枪</div>
                <div v-if="currentOilGunInfo" class="site-oil-gun-form-value">
                    <div class="site-oil-gun-form-value-left">{{ currentOilGunInfo.oil_type_text }}</div>
                    <div class="site-oil-gun-form-value-right">{{ currentOilGunInfo.name }}</div>
                </div>
                <div v-else class="site-oil-gun-form-value">
                    <div style="width: 100%; text-align: right; font-size: 25px; color: #cccccc;">请选择油枪</div>
                </div>
            </div>
            <template v-if="currentOilGunInfo">
                <div class="site-amount-form" v-if="currentRefuelMode === 'query_order'" @click="openOrderPopup">
                    <div class="site-amount-form-title">加油金额</div>
                    <div v-if="currentOrderInfo" class="site-amount-form-value">
                        <span class="site-amount-form-unit">￥</span>{{ currentOrderInfo.total }}
                    </div>
                    <div v-else class="site-amount-form-value">
                        <div style="width: 100%; text-align: right; font-size: 25px; color: #cccccc;">请选择订单</div>
                    </div>
                </div>
                <div class="site-amount-form" v-if="currentRefuelMode === 'input_total_amount'" @click="openRefuelAmount">
                    <div class="site-amount-form-title">加油金额</div>
                    <div v-if="oilForm.total_amount" class="site-amount-form-value">
                        <span class="site-amount-form-unit">￥</span> {{ oilForm.total_amount }}
                    </div>
                    <div v-else class="site-amount-form-value">
                        <div style="width: 100%; text-align: right; font-size: 25px; color: #cccccc;">请输入加油金额</div>
                    </div>
                </div>
            </template>
        </div>

        <template v-if="!currentCheckoutOrderInfo && isCheckoutLoading">
            <div style="padding: 100px;">
                <van-loading size="50px" vertical>加载中...</van-loading>
            </div>
        </template>
        <template v-else-if="currentCheckoutOrderInfo">
            <div class="order-container new-cell-group">
                <van-cell-group v-if="isShowOrderDetail" class="detail-container" title="订单信息">
                    <van-cell title="交易时间" :value="currentCheckoutOrderInfo.order_detail.detail.created_at"/>
                    <van-cell title="油品">
                        <div>
                            {{ currentCheckoutOrderInfo.order_detail.detail.oil_type.name }}
                        </div>
                    </van-cell>
                    <van-cell title="单价" :value="currentCheckoutOrderInfo.order_detail.detail.oil_price + '元/L'"></van-cell>
                    <van-cell title="油量" :value="currentCheckoutOrderInfo.order_detail.detail.oil_liter + 'L'"></van-cell>
                </van-cell-group>
                <div v-else style="text-align: center; padding-top: 20px; color: #666666;" @click="showOrderDetail">
                    展开查看订单详情
                    <van-icon name="arrow-down" />
                </div>

                <van-cell-group title="优惠">
                    <van-cell v-for="(discountItem, index) in currentCheckoutOrderInfo.order_detail.discount_detail" :key="index" value-class="money" :title="discountItem.name">
                        <span>{{discountItem.value < 0 ? '-￥' + (-discountItem.value) : ('￥' + discountItem.value)}}</span>
                    </van-cell>
                    <van-coupon-cell :coupons="couponList" :chosen-coupon="selectCouponIndex" @click="couponPopup = true"/>
                    <van-cell title="邀请人" :value="currentCheckoutOrderInfo.order_detail.inviter_user_nickname" v-if="currentCheckoutOrderInfo.order_detail.inviter_user_nickname" />
                </van-cell-group>

                <van-radio-group v-model="oilForm.payment_method" checked-color="#3874FC" @change="refreshCheckoutOrder" :disabled="isCheckoutLoading">
                    <van-cell-group title="请选择您的支付方式" class="payment-container">
                        <van-cell title="微信支付" clickable @click="isCheckoutLoading ? false : oilForm.payment_method = 'wechat_jsapi'">
                            <template #icon>
                                <van-radio name="wechat_jsapi"/>
                            </template>
                            <van-loading v-if="isCheckoutLoading && oilForm.payment_method === 'wechat_jsapi'" class="payment-loading" color="#1989fa"/>
                        </van-cell>
                        <van-cell v-if="!cardIsNull && oilForm.payment_method !== 'combination'" title="油卡支付" clickable class="payment-balance_is_insufficient" @click="isCheckoutLoading ? false : oilForm.payment_method = 'card'">
                            <template #icon>
                                <van-radio name="card"/>
                            </template>
                            <van-loading v-if="isCheckoutLoading && oilForm.payment_method === 'card'" class="payment-loading" color="#1989fa"/>
                        </van-cell>
                        <van-cell v-if="oilForm.payment_method === 'combination'" :title="'组合支付（' + $store.state.systemEnum.company.user_order.combination_payment_method[oilForm.combination_payment_method] + '）'" clickable class="payment-balance_is_insufficient" @click="isCheckoutLoading ? false : oilForm.payment_method = 'card'">
                            <template #icon>
                                <van-radio name="combination"/>
                            </template>
                            <van-loading v-if="isCheckoutLoading && oilForm.payment_method === 'combination'" class="payment-loading" color="#1989fa"/>
                        </van-cell>
                        <van-cell v-if="oilForm.payment_method === 'card' || oilForm.payment_method === 'combination'" icon="debit-pay"
                                  :title="cardInfos[0] ? 'No.' + (cardInfos[0].card_no || '') + (cardInfos.length > 1 ? '等共' + cardInfos.length + '张卡' : '') : '未选择'"
                                  is-link
                                  value-class="payment-balance"
                                  @click="showCardPop()">
                            <template #default>
                                <div>￥{{cardInfos.length ? cardBalance : ''}}</div>
                            </template>
                            <template #label>
                                <div>点击重新选择油卡</div>
                                <div class="payment-hint" v-if="cardDisabled">存在不可用卡片,请重新选择</div>
                                <template v-else>
                                    <div v-if="oilForm.payment_method === 'card' && isCombinationPayment && cardBalance < currentCheckoutOrderInfo.order_detail.paid_amount" class="payment-hint" style="text-decoration: underline;" @click.stop="isShowCombinationPaymentAction = true">余额不足，点击使用组合支付</div>
                                    <div v-if="oilForm.payment_method === 'combination'" class="payment-hint" style="text-decoration: underline;" @click.stop="switchUseCardPayment">切换使用油卡支付</div>
                                </template>
                            </template>
                        </van-cell>
                    </van-cell-group>
                    <van-cell-group v-if="cardIsNull" title="办理油卡">
                        <van-cell icon="debit-pay" title="开通油卡可享受优惠" arrow-direction="down" />
                        <van-cell title="一键办卡" is-link @click="toHandleCard" />
                        <van-cell title="绑定油卡" is-link @click="$router.push({name: 'Binding'})"/>
                    </van-cell-group>
                </van-radio-group>

                <van-cell-group v-if="oilForm.payment_method === 'combination'" title="组合支付详情">
                    <van-cell v-for="(paymentDetailItem, index) in currentCheckoutOrderInfo.order_detail.payment_detail" :key="index" value-class="money" :title="(paymentDetailItem.payment_method === 'card' ? '尾号' + paymentDetailItem.card_no.substr(-4, 4) : '') + $store.state.systemEnum.company.user_order.payment_method[paymentDetailItem.payment_method]">
                        <span><span style="color: #969799; font-size: 14px;">支付</span>{{'￥' + paymentDetailItem.payment_amount}}</span>
                    </van-cell>
                </van-cell-group>

                <van-submit-bar label="实付：" :price="currentCheckoutOrderInfo.order_detail.paid_amount*100 || 0"
                                text-align="left"
                                button-text="立即支付"
                                :disabled="oilForm.payment_method === 'card' && cardDisabled || isCheckoutLoading"
                                @submit="submitClick"/>
            </div>

            <van-popup v-model="showCard" position="bottom" round :close-on-click-overlay="false">
                <div class="popup_tit">
                    <span style="font-weight: bold; font-size: 18px;">选择油卡</span>
                    <van-button type="default" round size="small" style="margin-left: 10px; min-width: 70px" class="refresh-btn" @click="confirmSelectCard">确认</van-button>
                    <van-button type="default" round size="small" style="min-width: 70px" @click="cancelSelectCard">取消</van-button>
                </div>
                <div class="card-list">
                    <card-design v-for="(item, index) in currentCheckoutOrderInfo.user_card_list"
                                 :key="'card' + index"
                                 :card-info="item"
                                 :class="[{'item-disable': item.disabled}, 'card-item', {'item-selected': cardIds.indexOf(item.id) !== -1} ]"
                                 @click.native="selectCard(item)">
                        <div class="item-disable-shade" v-if="item.disabled">
                            <div class="message">
                                <van-icon name="warning-o" color="#ffffff" size="20"/>
                                <span>{{item.disabled_info.result == 'INSUFFICIENT_BALANCE' ? '余额不足，点击' : item.disabled_info.msg}}</span>
                                <span @click="toRechargeCard(item.id)" style="text-decoration: underline;" v-if="item.disabled_info.result == 'INSUFFICIENT_BALANCE'">充值</span>
                            </div>
                        </div>
                        <div class="item-active-shade">
                            <div v-if="cardIds.length > 1">
                                <div class="text"></div>
                                <span>{{cardIds.indexOf(item.id)+ 1}} </span>
                            </div>
                            <van-icon name="success" color="#ffffff" size="20" v-if="cardIds.length === 1"/>
                        </div>
                    </card-design>
                </div>
            </van-popup>

            <van-popup v-model="couponPopup" round position="bottom" style="height: 90%; padding-top: 4px; overflow: hidden;">
                <van-coupon-list :coupons="couponList" :chosen-coupon="selectCouponIndex" :disabled-coupons="disabledCouponList" @change="couponChange" :show-exchange-bar="false" />
            </van-popup>

            <van-popup v-model="showPaymentPassword" position="bottom" style="height: 90%;">
                <div style="font-size: 18px; text-align: center; padding: 30px 0 10px 0;">输入支付密码</div>
                <div style="text-align: center; color: #888888; padding: 10px;">请输入支付密码，用于验证支付</div>
                <van-password-input :value="oilForm.payment_password" :focused="showPaymentPasswordKeyboard" @focus="showPaymentPasswordKeyboard = true" />
                <van-number-keyboard v-model="oilForm.payment_password" :show="showPaymentPasswordKeyboard" :maxlength="6" />
            </van-popup>
        </template>

        <van-popup v-model="siteListPopup" round position="bottom" :close-on-click-overlay="currentSiteInfo !== null" :safe-area-inset-bottom="true" :style="{ height: '60%' }">
            <div class="popup-container">
                <div class="popup-container-title">请选择油站</div>
                <div class="popup-container-body">
                    <div v-if="isSiteLoading" style="padding: 50px;">
                        <van-loading size="50px" vertical>加载中...</van-loading>
                    </div>
                    <template v-else>
                        <div v-if="siteList.length > 0" :class="['site-item', { 'selected': selectSiteIndex === index }]" v-for="(item, index) in siteList" @click="selectSite(index)">
                            <div class="site-item-left">
                                <van-image  width="2.5rem" height="2.5rem" fit="cover" radius="5px" :src="item.image_src"></van-image>
                            </div>
                            <div class="site-item-right">
                                <div class="site-item-right-top">
                                    <div class="site-item-title">{{item.name}}</div>
                                    <div class="site-item-address" v-if="item.address">{{item.address || '缺少地址信息'}}</div>
                                </div>
                                <div class="site-item-right-bottom" v-if="item.distance">
                                    <van-icon name="location-o" style="vertical-align: middle;" />
                                    {{item.distance | distanceDataFormat}}
                                </div>
                            </div>
                        </div>
                        <van-empty v-else description="暂无油站" />
                    </template>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="oilGunListPopup" round position="bottom" :close-on-click-overlay="true" :safe-area-inset-bottom="true" :style="{ height: '60%' }">
            <div class="popup-container">
                <div class="popup-container-title">请选择油枪</div>
                <div class="popup-container-body">
                    <div v-if="isOilGunLoading" style="padding: 50px;">
                        <van-loading size="50px" vertical>加载中...</van-loading>
                    </div>
                    <template v-else>
                        <div v-if="oilGunList.length > 0">
                            <div class="oil-type-list">
                                <div v-for="(item, index) in oilGunOilTypeList" :class="['oil-type-item', { 'selected': filterOilTypeId === item.id }]" @click="oilTypeFilter(item.id)">{{item.name}}</div>
                            </div>
                            <van-divider>油枪</van-divider>
                            <div class="oil-gun-grid">
                                <van-grid :gutter="10">
                                    <van-grid-item v-for="(item, index) in oilGunList" :key="index" :class="{ 'selected': selectOilGunIndex === index }" v-if="!filterOilTypeId || filterOilTypeId === item.oil_type" @click="selectOilGun(index)">
                                        <div style="font-size: 30px; font-weight: bold;">{{item.name}}</div>
                                        <div>{{item.oil_type_text}}</div>
                                    </van-grid-item>
                                </van-grid>
                            </div>
                        </div>
                        <van-empty v-else description="暂无油枪" />
                    </template>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="orderListPopup" round position="bottom" :close-on-click-overlay="true" :safe-area-inset-bottom="true" :style="{ height: '60%' }" @close="stopOrderRefreshTimer">
            <div class="popup-container order-popup-container">
                <div class="popup-container-title">请选择订单</div>
                <div class="popup-container-body">
                    <div v-if="isOrderLoading" style="padding: 50px;">
                        <van-loading size="50px" vertical>加载中...</van-loading>
                    </div>
                    <template v-else>
                        <div v-if="orderList.length > 0" class="order-list">
                            <div class="order-item" v-for="(item, index) in orderList" :class="{ 'selected': selectOrderIndex === index }" @click="selectOrder(index)">
                                <div class="order-item-header">
                                    <div class="order-item-oil-type">{{ item.oil_type.name }}</div>
                                    <div class="order-item-datetime">{{ item.created_at | dateFormat('MM-dd hh:mm') }}</div>
                                </div>
                                <van-cell-group style="background-color: transparent;">
                                    <van-cell title="油价" :value="'￥' + item.oil_price + '/升'" />
                                    <van-cell title="油量" :value="item.oil_liter + '升'" />
                                </van-cell-group>
                                <div class="order-item-footer">
                                    加油金额：
                                    <span class="order-item-unit">￥</span>
                                    <span class="order-item-total">{{ item.total }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <van-empty v-if="orderErrStr" image="error" :description="orderErrStr" style="padding-bottom: 0;" />
                            <van-empty v-else description="暂无订单" style="padding-bottom: 0;" />
                            <div style="text-align: center;">
                                <div style="color: #999999; font-size: 18px;">将在{{ refreshOrderCountDown }}s后重新获取加油订单</div>
                                <div style="margin-top: 10px;">
                                    <van-button type="default" round style="min-width: 130px;" @click="reselectOilGunClick">重选油枪</van-button>
                                    <van-button type="default" round class="refresh-btn" style="min-width: 130px; margin-left: 10px;" @click="refreshOrderClick">刷新</van-button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="input-refuel-amount" v-if="refuelMode === 'auto' && orderQueryNoDataNum > 3">
                        没有您的订单？可尝试手工输入
                        <van-button type="default" round size="small" style="min-width: 90px; margin-left: 10px;" @click="inputRefuelAmountClick">手动输入</van-button>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-number-keyboard
            class="refuel-amount-keyboard"
            safe-area-inset-bottom
            :hide-on-click-outside="false"
            theme="custom"
            :show="refuelAmountKeyboard"
            :extra-key="['00', '.']"
            close-button-text="完成"
            @blur="refuelAmountKeyboardComplete"
            @input="refuelAmountKeyboardInput"
            @delete="refuelAmountKeyboardDelate">
            <div slot="title-left">
                <div class="fast-amount-list">
                    <div class="fast-amount-item" @click="fastRefuelAmount(100)"><span style="font-size: 14px;">￥</span>100</div>
                    <div class="fast-amount-item" @click="fastRefuelAmount(200)"><span style="font-size: 14px;">￥</span>200</div>
                    <div class="fast-amount-item" @click="fastRefuelAmount(300)"><span style="font-size: 14px;">￥</span>300</div>
                    <div class="fast-amount-item" @click="fastRefuelAmount(500)"><span style="font-size: 14px;">￥</span>500</div>
                </div>
            </div>
        </van-number-keyboard>

        <van-action-sheet v-model:show="isShowCombinationPaymentAction" :actions="combinationPaymentAction" cancel-text="取消" description="请选择需要组合支付的支付方式" close-on-click-action @select="combinationPaymentMethodSelect" />
    </div>
</template>

<script>
import common from '../../assets/js/common'
import wx from 'weixin-js-sdk'
import api from '../../assets/js/api'
import CardDesign from '../../components/beilin/CardDesign'
import { Dialog } from 'vant';

export default {
    name: 'Index',
    components: {CardDesign},
    data () {
        return {
            currentRefuelMode: 'query_order',  // 当前加油模式
            oilForm: {
                site_id: undefined,                          // 站点ID
                site_oil_gun_id: undefined,                  // 油枪ID
                order_id: undefined,                         // 订单ID
                total_amount: undefined,                     // 总金额
                longitude: undefined,
                latitude: undefined,
                payment_method: undefined,                   // 支付方式
                combination_payment_method: undefined,       // 组合支付方式
                user_card_id: undefined,                     // 卡片ID
                inviter_user_id: undefined,                  // 邀请用户ID
                user_coupon_id: undefined,                   // 用户优惠券ID
                payment_password: undefined,                 // 支付密码
            },
            isInitSite: false,
            siteListPopup: false,
            siteList: [],
            selectSiteIndex: null,
            isSiteLoading: false,

            oilGunListPopup: false,
            oilGunList: [],
            selectOilGunIndex: null,
            filterOilTypeId: null,
            isOilGunLoading: false,

            orderListPopup: false,
            orderList: [],
            selectOrderIndex: null,
            isOrderLoading: false,
            orderErrStr: null,
            orderQueryNoDataNum: 0,   // 订单查询无数据次数
            refreshOrderCountDown: 0,
            refreshOrderTimer: null,

            refuelAmountKeyboard: false,

            currentCheckoutOrderInfo: null,
            isCheckoutLoading: false,

            couponPopup : false,
            selectCouponIndex : -2,

            showCard: false,
            cardInfos: [],
            cacheCardInfos: [],

            showPaymentPassword : false,
            showPaymentPasswordKeyboard : true,

            isShowOrderDetail: false,

            isShowCombinationPaymentAction: false,
        };
    },
    computed: {
        refuelMode() {
            // 加油模式，auto/自动模式：如果有对接会优先查询订单模式，如果没查询到订单用户可选择输入加油金额方式支付。query_order/查询订单模式：只支持查询订单的方式。input_total_amount/输入加油金额模式：只支持输入加油金额模式。
            return this.$store.state.systemConfig['wechat.refuel_mode'];
        },
        isEnableConvenientlyBuy() {
            // 是否开启顺手购
            return this.$store.state.systemConfig['wechat.is_enable_conveniently_buy'];
        },
        currentSiteInfo(){
            if(this.selectSiteIndex === null) return null;
            return this.siteList[this.selectSiteIndex];
        },
        currentOilGunInfo(){
            if(this.selectOilGunIndex === null) return null;
            return this.oilGunList[this.selectOilGunIndex];
        },
        currentOrderInfo(){
            if(this.selectOrderIndex === null) return null;
            return this.orderList[this.selectOrderIndex];
        },
        oilGunOilTypeList(){
            let oilTypeArr = {};
            let oilGunList = this.oilGunList || [];
            for(let i = 0; i < oilGunList.length; i++){
                if(!oilTypeArr[oilGunList[i]['oil_type']]){
                    oilTypeArr[oilGunList[i]['oil_type']] = {
                        id: oilGunList[i]['oil_type'],
                        name: oilGunList[i]['oil_type_text'],
                    };
                }
            }
            return Object.values(oilTypeArr);
        },
        couponList(){
            let list = this.currentCheckoutOrderInfo && this.currentCheckoutOrderInfo.user_coupon || [];
            let couponArr = [];
            for (let index in list){
                let coupon = list[index];
                if(!coupon['disabled']){
                    couponArr.push(common.convertCouponData(coupon));
                    if(coupon['is_select']){
                        this.selectCouponIndex = couponArr.length - 1;
                    }
                }
            }
            return couponArr;
        },
        disabledCouponList(){
            let list = this.currentCheckoutOrderInfo && this.currentCheckoutOrderInfo.user_coupon || [];
            let couponArr = [];
            for (let index in list){
                let coupon = list[index];
                if(coupon['disabled']){
                    couponArr.push(common.convertCouponData(coupon));
                }
            }
            return couponArr;
        },
        cardIsNull(){
            if(!this.currentCheckoutOrderInfo) return false;
            return this.currentCheckoutOrderInfo.user_card_list.length <= 0;
        },
        cardIds() {
            let ids = []
            for (const card of this.cardInfos) {
                ids.push(card.id)
            }
            return ids
        },
        cardDisabled() {
            for (const card of this.cardInfos) {
                if (card.disabled) {
                    return true
                }
            }
            return false
        },
        isCardAllGift() {
            for (const card of this.cardInfos) {
                if (card.type !== 'GiftCard') {
                    return false
                }
            }
            return true
        },
        cardBalance() {
            let balance = 0;
            for (const card of this.cardInfos) {
                if (card.balance) {
                    balance = common.accAdd(balance, card.balance)
                }
            }
            return balance
        },
        // 是否组合支付
        isCombinationPayment(){
            let combinationPayment = false;
            for (const card of this.cardInfos) {
                if(!card.is_combination_payment) return false;
                else combinationPayment = true;
            }
            return combinationPayment;
        },
        combinationPaymentAction(){
            let combination_payment_method = this.$store.state.systemEnum.company.user_order.combination_payment_method || {};
            let combinationPaymentMethodArr = [];
            for (let key in combination_payment_method){
                combinationPaymentMethodArr.push({
                    key: key,
                    name: combination_payment_method[key],
                });
            }
            return combinationPaymentMethodArr;
        },
    },
    watch: {
        selectSiteIndex(newValue, oldValue){
            this.oilForm.site_id = this.currentSiteInfo && this.currentSiteInfo.id || undefined;
        },
        selectOilGunIndex(newValue, oldValue){
            this.oilForm.site_oil_gun_id = this.currentOilGunInfo && this.currentOilGunInfo.id || undefined;
        },
        selectOrderIndex(newValue, oldValue){
            this.oilForm.order_id = this.currentOrderInfo && this.currentOrderInfo.order_id || undefined;
        },
        selectCouponIndex(newValue, oldValue){
            this.refreshCheckoutOrder();
        },
        'oilForm.payment_password': function (newValue, oldValue){
            if(newValue && newValue.length >= 6){
                this.payment();
            }
        },
        '$store.state.systemConfig':function (newValue, oldValue){
            if(this.refuelMode === 'auto'){
                this.currentRefuelMode = newValue['interface_name'] === 'None' ? 'input_total_amount' : 'query_order';
            }else{
                this.currentRefuelMode = this.refuelMode;
            }
        },
    },
    created () {
        let self = this;

        // 邀请用户ID
        if (self.$route.query.inviter_user_id) {
            self.oilForm.inviter_user_id = self.$route.query.inviter_user_id || '';
            localStorage.setItem('consumeInviterInfo', JSON.stringify({
                id: self.$route.query.inviter_user_id,
            }));
        } else if (localStorage.getItem('consumeInviterInfo')) {
            let inviterInfo = JSON.parse(localStorage.getItem('consumeInviterInfo'));
            if (inviterInfo && inviterInfo.id) {
                self.oilForm.inviter_user_id = inviterInfo.id;
            }
        }

        common.wechatReady(() => {
            // 获取用户的位置信息
            wx.getLocation({
                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: (res => {
                    self.oilForm.longitude = res.longitude;
                    self.oilForm.latitude = res.latitude;
                    self.isInitSite = true;
                    self.refreshSite();
                }),
                fail: ((err) => {
                    self.$toast(err.errMsg || '定位失败');
                    self.isInitSite = true;
                    self.siteListPopup = true;
                    self.refreshSite();
                }),
                cancel: ((res) => {
                    self.$toast('用户拒绝授权获取地理位置');
                    self.isInitSite = true;
                    self.siteListPopup = true;
                    self.refreshSite();
                }),
            });
        });
        setTimeout(() => {
            if(!self.isInitSite) {
                self.isInitSite = true;
                self.siteListPopup = true;
                self.refreshSite();
            }
        }, 15000);
    },
    methods: {
        refreshSite(){
            let self = this;
            self.isSiteLoading = true;
            api.request('/site/list', self.oilForm).then(res => {
                self.siteList = res.data;

                if((self.oilForm.longitude && self.oilForm.latitude) || res.data.length === 1){
                    self.selectSite(0);
                }
            }).finally(() => {
                self.isSiteLoading = false;
            })
        },
        async selectSite(index){
            if(!(this.oilForm.longitude && this.oilForm.latitude)){
                let confirmRes = await Dialog.confirm({
                    title: '油站选择确认提示',
                    message: '请向加油员询问并确认是否您当前选择的油站名称',
                });
                if(confirmRes !== 'confirm') return;
            }

            this.selectSiteIndex = index;
            this.selectOilGunIndex = null;
            this.filterOilTypeId = null;
            this.selectOrderIndex = null;
            this.orderQueryNoDataNum = 0;
            this.oilForm.total_amount = undefined;
            this.currentCheckoutOrderInfo = null;
            this.siteListPopup = false;
            this.refuelAmountKeyboard = false;

            this.oilGunListPopup = true;
            this.refreshSiteOilGun();
        },
        refreshSiteOilGun(){
            let self = this;
            self.isOilGunLoading = true;
            api.request('/site/oil_gun_list', self.oilForm).then(res => {
                self.oilGunList = res.data;
            }).finally(() => {
                self.isOilGunLoading = false;
            });
        },
        selectOilGun(index){
            this.selectOilGunIndex = index;
            this.orderQueryNoDataNum = 0;
            this.oilGunListPopup = false;
            this.refuelAmountKeyboard = false;

            let currentRefuelMode = this.currentRefuelMode;
            if(currentRefuelMode === 'query_order'){
                this.openOrderPopup(true);
            }else if(currentRefuelMode === 'input_total_amount'){
                this.openRefuelAmount();
            }
        },
        oilTypeFilter(id){
            this.filterOilTypeId = (this.filterOilTypeId === id) ? null : id;
        },
        refreshOrder(autoSelect){
            let self = this;
            self.isOrderLoading = true;
            self.orderErrStr = null;
            api.request('/order/query', self.oilForm).then(res => {
                self.orderList = res.data;

                if(res.data.length <= 0){
                    self.orderQueryNoDataNum++;
                    self.startOrderRefreshTimer();
                }
                // 自动选择
                else if(autoSelect && res.data.length === 1){
                    self.selectOrder(0);
                }
                if(res.data.length > 0){
                    self.orderQueryNoDataNum = 0;
                }
            }).catch(err => {
                self.orderErrStr = err.msg;
                self.orderList = [];
                self.orderQueryNoDataNum++;
                self.startOrderRefreshTimer();
            }).finally(() => {
                self.isOrderLoading = false;
            });
        },
        startOrderRefreshTimer(){
            let self = this;
            let maxCountDown = 5;
            self.refreshOrderCountDown = maxCountDown;
            self.refreshOrderTimer = setInterval(function (){
                self.refreshOrderCountDown--;
                if(self.refreshOrderCountDown <= 0){
                    self.refreshOrder(true);
                    self.stopOrderRefreshTimer();
                }
            }, 1000);
        },
        stopOrderRefreshTimer(){
            if(this.refreshOrderTimer){
                clearInterval(this.refreshOrderTimer);
                this.refreshOrderTimer = null;
            }
        },
        reselectOilGunClick(){
            this.orderListPopup = false;
            this.oilGunListPopup = true;
        },
        refreshOrderClick(){
            this.stopOrderRefreshTimer();
            this.refreshOrder(true);
        },
        openOrderPopup(autoSelect){
            this.selectOrderIndex = null;
            this.currentCheckoutOrderInfo = null;
            this.oilForm.total_amount = undefined;
            this.orderListPopup = true;

            this.refreshOrder(autoSelect);
        },
        selectOrder(index){
            this.selectOrderIndex = index;
            this.orderQueryNoDataNum = 0;
            this.currentCheckoutOrderInfo = null;
            this.orderListPopup = false;

            this.refreshCheckoutOrder();
        },
        openRefuelAmount(){
            this.selectOrderIndex = null;
            this.currentCheckoutOrderInfo = null;
            this.refuelAmountKeyboard = true;
        },
        refuelAmountKeyboardInput(val){
            let currentAmount = this.oilForm.total_amount || '';
            if (currentAmount.length === 0 && val === '.' ||
                currentAmount.indexOf('.') >= 0 && val === '.' ||
                currentAmount.indexOf('.') > 0 && currentAmount.substr(currentAmount.indexOf('.')).length > 2 ||
                currentAmount === '0' && val !== '.' ||
                currentAmount.length >= 12) {
                return;
            }
            if(this.oilForm.total_amount === undefined){
                this.oilForm.total_amount = '';
            }
            this.oilForm.total_amount += val;

        },
        fastRefuelAmount(amount){
            this.oilForm.total_amount = amount.toString();
            this.refuelAmountKeyboardComplete();
        },
        refuelAmountKeyboardDelate(){
            let currentAmount = this.oilForm.total_amount || '';
            this.oilForm.total_amount = currentAmount.substr(0, currentAmount.length - 1);
        },
        refuelAmountKeyboardComplete(){
            let totalAmount = this.oilForm.total_amount;
            if(!totalAmount){
                this.$toast('请输入加油金额');
                return;
            }
            totalAmount = parseFloat(totalAmount);
            if(totalAmount <= 0){
                this.$toast('输入的加油金额必须大于0');
                return;
            }

            this.refuelAmountKeyboard = false;
            this.refreshCheckoutOrder();
        },
        refreshCheckoutOrder(){
            let self = this;
            self.isCheckoutLoading = true;
            self.oilForm.user_card_id = (self.oilForm.payment_method === 'card' || self.oilForm.payment_method === 'combination') ? self.cardIds : undefined;
            self.oilForm.user_coupon_id = self.selectCouponIndex === -1 ? undefined : (self.couponList[self.selectCouponIndex] ? self.couponList[self.selectCouponIndex]['info']['id'] : '');
            api.request('/order/checkout', self.oilForm).then(res => {
                // 删除优惠券优惠
                if (res.data.order_detail && res.data.order_detail.discount_detail) {
                    for(let index in res.data.order_detail.discount_detail){
                        if(res.data.order_detail.discount_detail[index]['name'] === '优惠券优惠'){
                            res.data.order_detail.discount_detail.splice(index, 1);
                        }
                    }
                }

                self.currentCheckoutOrderInfo = res.data;
                self.oilForm.payment_method = res.data.order_detail.payment_method;
                // 选择卡片
                if (self.cardInfos.length <= 0) {
                    self.cardInfos = [];
                    for (let item of res.data.user_card_list) {
                        if (item.is_select) {
                            self.cardInfos.push(item);
                        }
                    }
                }
            }).catch(err => {
                self.$toast(err.msg);

                let currentRefuelMode = self.currentRefuelMode;
                if(currentRefuelMode === 'query_order'){
                    this.openOrderPopup(true);
                }else if(currentRefuelMode === 'input_total_amount'){
                    this.openRefuelAmount();
                }
            }).finally(() => {
                self.isCheckoutLoading = false;
            })
        },
        couponChange(index){
            this.selectCouponIndex = index;
            this.couponPopup = false;
        },
        toHandleCard(){
            this.$router.push({ name: 'CardHandle' });
        },
        toRechargeCard (id) {
            this.$router.push({name: 'Recharge', query: {from: 'order', user_card_id: id}})
        },
        showCardPop() {
            this.cacheCardInfos = [].concat(this.cardInfos)
            this.showCard = true;
        },
        selectCard (card) {
            let index = this.cardIds.indexOf(card.id);
            if (!card.disabled || card.disabled && index !== -1) {
                if (index === -1) {
                    if (this.cardInfos.length > 0) {
                        if (this.isCardAllGift) {
                            if (card.type === 'GiftCard') {
                                this.cardInfos.push(card);
                            } else {
                                this.$toast('只有礼品卡可以多选');
                                return;
                            }
                        } else {
                            this.cardInfos = [];
                            this.cardInfos.push(card);
                            return;
                        }
                    } else {
                        this.cardInfos.push(card);
                        return;
                    }
                } else {
                    this.cardInfos.splice(index, 1);
                    return
                }
            }
        },
        confirmSelectCard () {
            if (this.cardInfos.length === 0) {
                this.$toast('请选择至少一张油卡');
                return;
            }
            this.showCard = false;
            this.oilForm.payment_method = 'card';
            this.oilForm.combination_payment_method = undefined;
            this.refreshCheckoutOrder();
        },
        cancelSelectCard() {
            this.showCard = false;
            this.cardInfos = [].concat(this.cacheCardInfos)
        },
        submitClick(){
            let self = this;
            if(self.oilForm.payment_method === 'card' || self.oilForm.payment_method === 'combination'){
                api.request('/user/is_payment_password').then(res => {
                    if(!res.data.is_payment_pasword){
                        self.$beilinTools.setPaymentPasswordPopup().open();
                        self.$toast('您还未设置支付密码，请设置');
                    }else{
                        self.oilForm.payment_password = undefined;
                        self.showPaymentPassword = true;
                    }
                });
            }else{
                self.payment();
            }
        },
        // 支付订单
        payment () {
            let self = this;
            this.$toast.loading({
                message: '支付中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0,
            });
            self.oilForm.user_card_id = (self.oilForm.payment_method === 'card' || self.oilForm.payment_method === 'combination') ? self.cardIds : undefined;
            self.oilForm.user_coupon_id = self.selectCouponIndex === -1 ? undefined : (self.couponList[self.selectCouponIndex] ? self.couponList[self.selectCouponIndex]['info']['id'] : '');
            api.request('/order/payment', self.oilForm).then(res => {
                self.showPaymentPassword = false;
                self.oilForm.payment_password = undefined;

                if(!res.data.payment_info){
                    self.paymentSuccess(res.data.order_no);

                }else{
                    let payInfo = JSON.parse(res.data.payment_info);
                    let order_id = res.data.order_no;
                    common.wechatPayReady(payInfo.appId, () => {
                        wx.chooseWXPay({
                            timestamp: payInfo.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                            nonceStr: payInfo.nonceStr, // 支付签名随机串，不长于 32 位
                            package: payInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                            signType: payInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                            paySign: payInfo.paySign, // 支付签名
                            // 支付成功后的回调函数
                            success: (res) => {
                                self.paymentSuccess(order_id);
                            },
                            cancel () {
                                self.$toast.clear();
                                self.$toast.fail('正在取消订单');
                                api.request('/order/cancel', {
                                    order_no: order_id,
                                }).then(res => {
                                    self.$toast.fail('订单已取消');
                                }).catch(res => {
                                    self.$toast.fail('订单取消失败');
                                });
                            },
                            fail: (err) => {
                                self.$toast.clear();
                                self.$toast(err.errMsg);
                            },
                        });
                    });
                }
            }).catch(err => {
                self.$toast.clear();
                self.$toast(err.msg);
                this.oilForm.payment_password = undefined;
            }).finally(() => {

            })
        },
        paymentSuccess(orderNo) {
            let self = this;
            self.$toast.clear();
            self.removeInviter();
            self.$toast.success({
                message: '支付成功',
                onClose () {
                    if(self.isEnableConvenientlyBuy){
                        self.$router.push({
                            name: 'HandyPurchase',
                            query: {
                                site_id: self.currentSiteInfo.id,
                            }
                        });
                        return;
                    }

                    self.$router.push({
                        name: 'ConsumeDetail',
                        query: {
                            orderNo: orderNo,
                        }
                    });
                }
            });
        },
        //支付成功后清除邀请人
        removeInviter() {
            if (this.oilForm.inviter_user_id) {
                localStorage.removeItem('consumeInviterInfo');
            }
            this.oilForm.inviter_user_id = undefined;
        },
        showOrderDetail(){
            this.isShowOrderDetail = true;
        },
        inputRefuelAmountClick(){
            this.currentRefuelMode = 'input_total_amount';
            this.orderListPopup = false;
            this.openRefuelAmount();
        },
        combinationPaymentMethodSelect(action, index){
            this.oilForm.payment_method = 'combination';
            this.oilForm.combination_payment_method = action.key;
            this.refreshCheckoutOrder();
        },
        switchUseCardPayment(){
            this.oilForm.payment_method = 'card';
            this.oilForm.combination_payment_method = undefined;
            this.refreshCheckoutOrder();
        },
    },
}
</script>

<style lang="scss" scoped>
    .container{
        padding: 20px;
    }

    .popup-container{
        display: flex;
        flex-direction: column;
        height: 100%;

        .popup-container-title{
            text-align: center;
            font-size: 18px;
            height: 50px;
            line-height: 50px;
            font-weight: bold;
        }
        .popup-container-body{
            height: 100%;
            overflow: auto;
            background-color: #f6f6f6;
        }
    }

    .site-form{
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        cursor: pointer;

        .site-form-left{
            font-size: 18px;
            font-weight: bold;
        }
        .site-form-right{
            color: #999999;
        }
    }

    .site-main-form{
        background-color: #FFFFFF;
        border-radius: 10px;
        padding: 10px 15px;

        .site-oil-gun-form,
        .site-amount-form{
            cursor: pointer;

            .site-oil-gun-form-title,
            .site-amount-form-title{
                font-size: 16px;
                font-weight: bold;
            }
            .site-oil-gun-form-value,
            .site-amount-form-value{
                font-size: 40px;
                text-align: right;
                font-weight: bold;
                min-height: 45px;
            }
        }

        .site-oil-gun-form{

            .site-oil-gun-form-title{
            }
            .site-oil-gun-form-value{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;

                .site-oil-gun-form-value-left{
                    font-size: 20px;
                    flex: 1;
                    text-align: left;
                    font-weight: initial;
                    padding-bottom: 8px;
                    color: #2166E1;
                }
                .site-oil-gun-form-value-right{
                }
            }
        }

        .site-amount-form{
            border-top: 1px solid #f5f5f5;
            padding-top: 10px;
            margin-top: 10px;

            .site-amount-form-title{
            }
            .site-amount-form-value{
                .site-amount-form-unit{
                    font-size: 18px;
                }
            }
        }
    }

    .site-item {
        margin: 10px;
        background: #fff;
        padding: 10px 15px;
        border: 1px solid #efefef;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;

        .site-item-left{
        }

        .site-item-right{
            padding-left: 10px;
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: space-between;

            .site-item-right-top{

            }
            .site-item-right-bottom{
                text-align: right;
                color: #cccccc;
            }
        }

        .site-item-title {
            font-size: 16px;
            font-weight: bold;
            line-height: 20px;
            text-overflow:ellipsis;
            white-space: nowrap;
            overflow:hidden;
            margin-top: 2px;
        }

        .site-item-address {
            margin-top: 4px;
            font-size: 12px;
            color: #999;
        }

        &.selected {
            border: 1px solid #2166E1;
            background-color: #f5f8ff;
        }
    }

    .oil-type-list{
        overflow: auto;
        white-space: nowrap;
        padding: 10px;

        .oil-type-item{
            display: inline-block;
            background-color: #FFFFFF;
            margin-right: 10px;
            padding: 10px 15px;
            border-radius: 5px;
            font-size: 18px;

            &.selected {
                border: 1px solid #2166E1;
                background-color: #f5f8ff;
            }
        }
    }

    .order-list{
        padding: 10px;

        .order-item{
            background-color: #FFFFFF;
            border-radius: 10px;
            margin-bottom: 10px;

            .order-item-header,
            .order-item-footer{
                padding: 10px 15px;
            }
            .order-item-header{
                display: flex;
                justify-content: space-between;
            }
            .order-item-footer{
                text-align: right;
            }

            .order-item-oil-type{
                font-size: 16px;
                color: #2166E1;
            }
            .order-item-datetime{
                font-size: 14px;
                color: #666666;
            }
            .order-item-unit{
                color: #e70808;
            }
            .order-item-total{
                font-size: 20px;
                color: #e70808;
            }

            &.selected {
                /*border: 1px solid #2166E1;*/
            }
        }
    }

    .order-popup-container{
        .popup-container-body{
            position: relative;

            .input-refuel-amount{
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 0;
                text-align: center;
                background-color: #2166E1;
                color: #FFFFFF;
                padding: 5px;
            }
        }
    }

    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            .order-container {
                padding-bottom: 70px;
            }

            .order-item-tag {
                background-color: themed('colorTag');
            }

            .order-item-submit {
                .van-submit-bar__price {
                    color: themed('colorText');
                    font-size: 0.4rem;
                }
                .van-submit-bar__price--integer {
                    color: themed('colorText');
                    font-size: 0.6rem;
                }
                .van-button {
                    background: linear-gradient(to right,themed('colorGradientLeft'),themed('colorGradientRight'));
                }
            }

            .van-cell-group{
                .van-cell{
                    width: 100%;
                }
            }

            .detail-container{
                .van-cell__value {
                    font-size: 16px;
                }
            }

            .payment-container {
                position: relative;

                .van-cell .van-cell__title {
                    margin-left: 10px;
                }
                .van-cell__value{
                    position: static;
                    overflow: auto;
                }
                .payment-balance{
                    flex: initial;
                    font-size: 16px;
                }
                .payment-hint{
                    color: themed('colorText');
                }

                .payment-loading {
                    position: absolute;
                    right: 20px;
                }
            }

            .money {
                font-size: 18px;
                color: #e10000;
                font-weight: 400;
            }
            /deep/.van-coupon-cell__value--selected {
                font-size: 18px;
                color: #e10000;
            }

            .van-popup {
                .popup_tit {
                    border-bottom: none;
                    box-shadow: 0 5px 5px 0 rgba(0, 0, 0, .4);
                }

                .card-list-button {
                    background-color: themed('colorButton');
                    border-color: themed('colorButton');
                    color: #fff;
                }

                .card-list {
                    height: 80vh;
                    overflow-y: auto;
                    flex-flow: column;
                    align-items: center;
                    padding: 10px 0;
                    background: #f6f6f6;
                }

                .card-item {
                    margin: 20px auto;
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .4);
                }
            }

            .van-submit-bar__button--danger{
                background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
            }

        }

        .item-selected {
            border: 5px solid #2166E1;

            .item-active-shade {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                display: flex;
                justify-content: flex-end;
                align-items: flex-end;
                background: rgba(0, 0, 0, .2);

                i {
                    position: relative;
                    display: block;
                    margin-bottom: -2px;
                    margin-right: -2px;
                    width: 0;
                    height: 0;
                    border-top: transparent solid 15px;
                    border-left: transparent solid 15px;
                    border-bottom: #2166E1 solid 15px;
                    border-right: #2166E1 solid 15px;
                }

                .text {
                    position: absolute;
                    right: -2px;
                    bottom: -2px;
                    display: block;
                    z-index: 1000;
                    width: 0;
                    height: 0;
                    border-top: transparent solid 15px;
                    border-left: transparent solid 15px;
                    border-bottom: #2166E1 solid 15px;
                    border-right: #2166E1 solid 15px;
                    border-bottom-right-radius: 10px;
                }

                i:before {
                    position: absolute;
                    right: -17px;
                    bottom: -17px;
                    display: block;
                    transform: rotate(-30deg);
                }

                span {
                    position: absolute;
                    font-size: 12px;
                    right: 3px;
                    bottom: 2px;
                    z-index: 1001;
                    display: block;
                }
            }

        }

        .item-active-shade {
            display: none;
        }

    }
    .item-disable-shade {
        display: none;
        transition: all 0.3s;
        border-radius: 10px;
    }

    .item-disable {
        position: relative;
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, .4);

        &:after {
            border: none;
        }

        .item-disable-shade {
            z-index: 1000;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, .2);

            .message {
                padding: 10px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(0, 0, 0, .4);
            }

            span {
                margin-left: 10px;
            }
        }
    }

    .refresh-btn{
        background: linear-gradient(180deg, #2166E1 0%, #72A2FA 100%);
        color: #FFFFFF;
    }
</style>
<style lang="scss">
.oil-gun-grid{
    padding: 0 0 10px 0;

    .van-grid{
        .van-grid-item{
            .van-grid-item__content{
                border-radius: 10px;

                &::after{
                    border-radius: 10px;
                }
            }

            &.selected{
                .van-grid-item__content{
                    background-color: #f5f8ff;

                    &::after{
                        border: 1px solid #2166E1;
                    }
                }
            }
        }
    }
}

.refuel-amount-keyboard{
    .van-number-keyboard__header{
        height: 50px;

        .van-number-keyboard__title-left{
            width: 100%;
        }
    }
    .fast-amount-list{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 3px;

        .fast-amount-item{
            flex: 1;
            text-align: center;
            padding-top: 8px;
            padding-bottom: 8px;
            background-color: #2166E1;
            color: #FFFFFF;
            font-size: 20px;
            margin: 3px;
            border-radius: 1000px;
            font-weight: bold;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/oiling2/Index.vue